import * as React from 'react';

export enum FetchStatus {
  NONE,
  PENDING,
  SUCCESS,
  ERROR,
}

type UseFetchStatusResponse = {
  fetchStatus: FetchStatus;
  setNone: () => void;
  setPending: () => void;
  setSuccess: () => void;
  setError: () => void;
};

export default (): UseFetchStatusResponse => {
  const [fetchStatus, setFetchStatus] = React.useState<FetchStatus>(
    FetchStatus.NONE,
  );

  return {
    fetchStatus,
    setNone: () => setFetchStatus(FetchStatus.NONE),
    setPending: () => setFetchStatus(FetchStatus.PENDING),
    setSuccess: () => setFetchStatus(FetchStatus.SUCCESS),
    setError: () => setFetchStatus(FetchStatus.ERROR),
  };
};
